import { PDFPage } from "pdf-lib";
import { isNil } from "ramda";
import { CommonDrawOptions, DocumentPlaceholder } from "../types";
import { scaleIntoBox, strToUint8Array } from "../utils";

export interface SignaturePlaceholderData {
  signature: string;
}

export type SignaturePlaceholderOptions = any;

export const signatureDraw = async (
  page: PDFPage,
  placeholder: DocumentPlaceholder<SignaturePlaceholderOptions, SignaturePlaceholderData>,
  { pdfDoc }: CommonDrawOptions
) => {
  if (isNil(placeholder.data)) {
    throw new Error("Signature placeholder data is missing");
  }

  const signatureBytes = await strToUint8Array(placeholder.data.signature);

  const signature = pdfDoc.embedPng(signatureBytes);
  const signatureData = await signature;

  const imageDimension = { width: signatureData.width, height: signatureData.height };

  const boxPxWidth = placeholder.width * page.getSize().width;
  const boxPxHeight = placeholder.height * page.getSize().height;

  const { width, height } = scaleIntoBox(imageDimension, {
    width: boxPxWidth,
    height: boxPxHeight,
  });

  const x = placeholder.x * page.getSize().width + (width < boxPxWidth ? boxPxWidth / 2 - width / 2 : 0);
  const y =
    page.getSize().height -
    placeholder.y * page.getSize().height -
    height -
    (height < boxPxHeight ? boxPxHeight / 2 - height / 2 : 0);

  page.drawImage(signatureData, {
    x: x,
    y: y,
    width: width,
    height: height,
  });
};
